import { SocialFeedIcon } from '@/assets/icons/socialFeed';
import { Text } from '@/components/TextComponent';
import { Box, BoxProps } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type EmptyFeedProps = BoxProps & {
    message?: string;
    pageHeight?: number;
};

export const EmptyFeed = ({
    message = 'There are currently no entries on the feed',
    pageHeight,
    ...boxProps
}: EmptyFeedProps) => {
    return (
        <Box height={pageHeight} paddingVertical={'s12'} alignItems={'center'} justifyContent={'center'} {...boxProps}>
            <Box
                width={64}
                height={64}
                borderRadius={'r64'}
                backgroundColor={ds.colorToken.background.neutral.subtler}
                marginBottom={'s12'}
                alignItems={'center'}
                justifyContent={'center'}
            >
                <SocialFeedIcon width={32} height={32} />
            </Box>
            <Text variant={'bodyMedium'} color={'neutral300'} maxWidth={250} textAlign={'center'}>
                {message}
            </Text>
        </Box>
    );
};
